import { combineReducers } from 'redux';
import { userReducer } from "./user-feature";
import { requestReducer } from "./request-feature";
import { exceptionReducer } from './exception-feature';

export const rootReducer = combineReducers({ user: userReducer, requests: requestReducer, exception: exceptionReducer});

export default rootReducer;